import React from "react";
import "./Sidebar.css";

const SidebarSkeleton: React.FC = () => {
  return (
    <aside className="sidebar">
      <div className="sidebar-menu">
        {/* Dashboard Link Skeleton */}
        <div className="skeleton-item skeleton-link"></div>
        <div className="sidebar-separator"></div>

        {/* Sections */}
        {[1, 2, 3].map((section) => (
          <div key={section} className="sidebar-section">
            <div className="skeleton-item skeleton-heading"></div>
            {[1, 2, 3].map((item) => (
              <div key={item} className="skeleton-item skeleton-link"></div>
            ))}
          </div>
        ))}
      </div>
    </aside>
  );
};

export default SidebarSkeleton;
